/* ==========================================================================
   Find your Mukhi — accordion behaviour
   - Progressive enhancement (adds .is-enhanced, then collapses)
   - Single (accordion) or multiple open modes
   - Idempotent init, safe with multiple sections on a page
   - Accessible: aria-expanded + inert on closed panels
   - Theme editor aware (section load, block select)
   ========================================================================== */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.mukhiReady === 'true') return;
    root.dataset.mukhiReady = 'true';

    var mode = root.getAttribute('data-expand-mode') || 'single';
    var openFirst = root.getAttribute('data-open-first') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mukhi-item]'));

    function triggerOf(item) { return item.querySelector('[data-mukhi-trigger]'); }
    function panelOf(item) { return item.querySelector('[data-mukhi-panel]'); }

    function setOpen(item, open) {
      var trigger = triggerOf(item);
      var panel = panelOf(item);
      if (!trigger || !panel) return;

      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        panel.removeAttribute('inert');
        panel.removeAttribute('aria-hidden');
      } else {
        // Keep collapsed content out of the tab order / a11y tree.
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
      }
    }

    function openItem(item) {
      if (mode === 'single') {
        items.forEach(function (other) {
          if (other !== item) setOpen(other, false);
        });
      }
      setOpen(item, true);
    }

    function toggleItem(item) {
      if (item.classList.contains('is-open')) {
        setOpen(item, false);
      } else {
        openItem(item);
      }
    }

    // Enhance: now that JS is running, let CSS take over collapsing.
    root.classList.add('is-enhanced');

    // Baseline: everything closed (also sets inert on closed panels).
    items.forEach(function (item) {
      var trigger = triggerOf(item);
      if (!trigger) return; // static item (no expandable content)
      setOpen(item, false);
      trigger.addEventListener('click', function () { toggleItem(item); });
    });

    if (openFirst) {
      for (var i = 0; i < items.length; i++) {
        if (triggerOf(items[i])) { openItem(items[i]); break; }
      }
    }

    // Helper used by the theme editor to reveal a selected block.
    root._mukhiOpenByBlockId = function (blockId) {
      if (!blockId) return;
      for (var j = 0; j < items.length; j++) {
        if (items[j].getAttribute('data-block-id') === blockId && triggerOf(items[j])) {
          openItem(items[j]);
          return;
        }
      }
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mukhi]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* ---------- Shopify theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mukhi]');
    if (root) { root.dataset.mukhiReady = ''; initSection(root); }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var detail = e.detail || {};
    var sectionEl = document.getElementById('shopify-section-' + detail.sectionId);
    var root = sectionEl
      ? sectionEl.querySelector('[data-mukhi]')
      : (e.target.querySelector ? e.target.querySelector('[data-mukhi]') : null);
    if (root && typeof root._mukhiOpenByBlockId === 'function') {
      root._mukhiOpenByBlockId(detail.blockId);
    }
  });
})();
